import { useAppState } from '../../AppContext';
import { keywordWidth, metadataColumnWidth, textHeight } from './constants';
import React, { useState } from 'react';
import { BiArrowToLeft } from 'react-icons/bi';
import { FaEye, FaSortAlphaDown, FaLayerGroup } from 'react-icons/fa';

import PropTypes from 'prop-types';

const ColumnButton = ({ x, actionType, columnName, tooltip, Icon, color }) => {
  let [, dispatch] = useAppState();

  return (
    <g transform={`translate(${x}, ${textHeight})`}>
      {/* background rect to provide a larger click target */}
      <rect
        x={0}
        y={0}
        width={keywordWidth}
        height={keywordWidth}
        fill={'white'}
        onClick={() => dispatch({ type: actionType, columnName: columnName })}
      />

      <Icon
        title={tooltip}
        color={color}
        onClick={() => dispatch({ type: actionType, columnName: columnName })}
      />
      <title>{tooltip}</title>
    </g>
  );
};

ColumnButton.propTypes = {
  x: PropTypes.number,
  actionType: PropTypes.string,
  columnName: PropTypes.string,
  tooltip: PropTypes.string,
  Icon: PropTypes.func,
  color: PropTypes.string
};

const MetadataColumnLabels = ({ metadataColumns, selectedColumn }) => {
  let [{ sortBy, groupBy }, dispatch] = useAppState();

  const [reorderingState, setReorderingState] = useState(null);

  const onArrowClick = (keyword, direction) => {
    console.log(`clicked: ${keyword}, ${direction}`);
    reorderingState &&
    reorderingState.keyword === keyword &&
    reorderingState.direction === direction
      ? setReorderingState(null)
      : setReorderingState({ keyword, direction: direction });
  };

  const arrowColor = (keyword, direction) => {
    return reorderingState &&
      reorderingState.keyword === keyword &&
      reorderingState.direction === direction
      ? 'gold'
      : 'black';
  };

  const keywordClick = (keyword) => {
    if (!reorderingState) {
      return;
    }

    if (reorderingState.keyword === keyword) {
      setReorderingState(null);
      return;
    }

    dispatch({
      type: 'REORDER_METADATA_COLUMNS',
      firstKeyword: keyword,
      secondKeyword: reorderingState.keyword
    });

    setReorderingState(null);
  };

  return (
    <g>
      {/* Keyword labels */}
      {metadataColumns.map((columnName, i) => {
        const x = i * metadataColumnWidth;

        const iconX = i * metadataColumnWidth;

        return (
          <React.Fragment key={i}>
            <text
              transform={`translate(${x}, ${textHeight - 10})`}
              fill={selectedColumn === columnName ? 'black' : 'gray'}
              onClick={() => keywordClick(columnName)}
              textAnchor="start"
            >
              {columnName}
            </text>

            <ColumnButton
              x={i * metadataColumnWidth}
              columnName={columnName}
              actionType={'TOGGLE_METADATA_COLUMN'}
              tooltip={'Click to hide this column'}
              Icon={FaEye}
              color={'lightgrey'}
            />

            <ColumnButton
              x={i * metadataColumnWidth + 20}
              columnName={columnName}
              actionType={'SORT_BY'}
              tooltip={
                'Click to sort documents within group based on this column'
              }
              Icon={FaSortAlphaDown}
              color={sortBy === columnName ? 'black' : 'lightgrey'}
            />

            <ColumnButton
              x={i * metadataColumnWidth + 20 * 2}
              columnName={columnName}
              actionType={'GROUP_BY'}
              tooltip={'Click to group documents based on this column'}
              Icon={FaLayerGroup}
              color={groupBy === columnName ? 'black' : 'lightgrey'}
            />

            <g
              transform={`translate(${iconX}, ${
                textHeight + 30 - keywordWidth / 2
              })`}
            >
              <rect
                x={0}
                y={0}
                width={keywordWidth}
                height={keywordWidth}
                fill="white"
                stroke="none"
                onClick={() => onArrowClick(columnName, 'after')}
              >
                <title>
                  Click here then click on another keyword label to move after
                  that label
                </title>
              </rect>
              <BiArrowToLeft
                size={keywordWidth}
                color={arrowColor(columnName, 'after')}
                onClick={() => onArrowClick(columnName, 'after')}
              >
                <title>
                  Click here then click on another keyword label to move after
                  that label
                </title>
              </BiArrowToLeft>
            </g>
          </React.Fragment>
        );
      })}
    </g>
  );
};

MetadataColumnLabels.propTypes = {
  metadataColumns: PropTypes.arrayOf(PropTypes.string),
  selectedColumn: PropTypes.string
};

export default MetadataColumnLabels;
